module.exports = __webpack_public_path__ + "static/media/Foothill.ebabb623.png";